import { Spin } from 'antd'

const Loader = () => {
    return (
        <div style={{ width: '100%', display: 'flex', justifyContent: 'center', padding: 40 }}>
            <Spin size="large" />
        </div>
    )
}

export default Loader